import { render } from "./DialogReservationSuccessful.vue?vue&type=template&id=0a1280ca"
import script from "./DialogReservationSuccessful.vue?vue&type=script&lang=js"
export * from "./DialogReservationSuccessful.vue?vue&type=script&lang=js"
script.render = render

export default script